import { render, staticRenderFns } from "./modal-commission.vue?vue&type=template&id=06139135&scoped=true"
import script from "./modal-commission.vue?vue&type=script&lang=js"
export * from "./modal-commission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06139135",
  null
  
)

export default component.exports